var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCorner01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "155.395px",
    height: "143.242px",
    viewBox: "56.02 99.978 155.395 143.242",
    enableBackground: "new 56.02 99.978 155.395 143.242",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#143A2B",
    d: "M195.44,199.152c-2.238,0-4.428-0.906-6.002-2.489c-1.579-1.579-2.492-3.767-2.492-6 c0-2.234,0.913-4.424,2.492-6.004c1.574-1.574,3.764-2.483,6.002-2.483c2.23,0,4.42,0.909,6,2.483 c1.579,1.58,2.487,3.77,2.487,6.004c0,2.233-0.908,4.425-2.487,6C199.86,198.246,197.67,199.152,195.44,199.152z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#143A2B",
    d: "M132.055,242.915c-2.238,0-4.425-0.903-6.004-2.485c-1.579-1.578-2.491-3.763-2.491-5.999 c0-2.238,0.912-4.425,2.491-6.004s3.766-2.489,6.004-2.489c2.233,0,4.422,0.91,5.996,2.489c1.582,1.579,2.488,3.766,2.488,6.004 c0,2.236-0.906,4.425-2.488,5.999C136.477,242.011,134.289,242.915,132.055,242.915z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M140.995,140.781c0,4.784,3.896,8.677,8.68,8.677s8.678-3.893,8.678-8.677c0-4.782-3.894-8.68-8.678-8.68 S140.995,135.999,140.995,140.781z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M149.674,149.458c4.784,0,8.678-3.893,8.678-8.677c0-4.782-3.894-8.68-8.678-8.68s-8.68,3.897-8.68,8.68 C140.995,145.565,144.89,149.458,149.674,149.458z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M149.674,149.458c4.784,0,8.678-3.893,8.678-8.677c0-4.782-3.894-8.68-8.678-8.68s-8.68,3.897-8.68,8.68 C140.995,145.565,144.89,149.458,149.674,149.458z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M158.352,140.781c0-4.782-3.894-8.68-8.678-8.68s-8.68,3.897-8.68,8.68c0,4.784,3.896,8.677,8.68,8.677 S158.352,145.565,158.352,140.781z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1CA94B",
    d: "M211.393,108.2c-13.086-5.298-27.387-8.222-42.372-8.222c-62.409,0-113.001,50.592-113.001,112.999 c0,10.476,1.432,20.616,4.1,30.243h29.779c-3.594-9.396-5.582-19.585-5.582-30.243c0-46.781,37.921-84.704,84.704-84.704 c15.442,0,29.905,4.153,42.372,11.373V108.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#143A2B",
    d: "M211.393,150.72h-20.785c-4.687,0-8.487,3.311-8.487,8s3.801,8,8.487,8h20.785V150.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#143A2B",
    d: "M160.481,216.774l8.995,6.745l0.312,0.198c1.147,0.713,2.264,1.443,3.355,2.187 c-0.436-0.021-0.877-0.029-1.318-0.029c-11.255,0-20.836,7.268-24.297,17.346h21.792c0.794-0.238,1.634-0.369,2.505-0.369 s1.712,0.131,2.507,0.369h37.083c-6.706-12.987-17.834-24.615-32.33-33.713l-8.961-6.73l-0.291-0.183 c-1.05-0.659-2.068-1.331-3.06-2.014h7.234c4.689,0,8.493-3.8,8.493-8.488c0-4.688-3.804-8.492-8.493-8.492h-20.966 c-2.535,0-4.822-1.093-6.405-2.835c-0.54-0.812-1.072-1.641-1.567-2.462c-0.434-1.034-0.679-2.186-0.679-3.375 c0-4.339,3.188-7.952,7.348-8.584c0.299-0.023,0.598-0.05,0.896-0.087c0.034,0,0.069-0.008,0.101-0.01 c12.707-1.518,22.594-12.357,22.594-25.467c0-3.113-0.555-6.102-1.579-8.865h21.766c4.69,0,8.492-3.802,8.492-8.488 c0-4.692-3.802-8.494-8.492-8.494h-42.5c-2.118-0.213-7.307-0.382-13.112,2.063c-6.384,2.689-14.655,9.054-17.811,24.115 c-2.811,13.378-1.019,27.261,5.177,40.154C133.899,195.056,145.073,206.998,160.481,216.774z M149.674,132.101 c4.784,0,8.678,3.897,8.678,8.68c0,4.784-3.894,8.677-8.678,8.677s-8.68-3.893-8.68-8.677 C140.995,135.999,144.89,132.101,149.674,132.101z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCorner01);
export default __webpack_public_path__ + "static/media/logo_corner-01.0ceb6cea0370b13d0a3133d15d2954d3.svg";
export { ForwardRef as ReactComponent };